import { render, staticRenderFns } from "./DocusignEditTemplateAdditionalDocument.vue?vue&type=template&id=3a3fbf6a&"
import script from "./DocusignEditTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"
export * from "./DocusignEditTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports